import { render, staticRenderFns } from "./summary-prf-imp-business.vue?vue&type=template&id=2c683207"
import script from "./summary-prf-imp-business.vue?vue&type=script&lang=js"
export * from "./summary-prf-imp-business.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports